import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { UserPlus, AlertCircle, CheckCircle, ChevronDown } from 'lucide-react';
import { customersAPI } from '../../services/api';
import GregorianDatePicker from '../../components/GregorianDatePicker';

const NewCustomer = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [countryCode, setCountryCode] = useState('+966');
  
  const [formData, setFormData] = useState({
    full_name: '',
    nationality: 'السعودية',
    identity_type: 'ID',
    national_id: '',
    phone: '',
    age: '',
    date_of_birth: '',
    email: '',
    address: '',
    patient_history: '',
    reference_mrn: '',
    gender: 'Male',
  });

  const countries = [
    { code: '+966', flag: '🇸🇦', name: 'السعودية', nameEn: 'Saudi Arabia' },
    { code: '+971', flag: '🇦🇪', name: 'الإمارات', nameEn: 'UAE' },
    { code: '+965', flag: '🇰🇼', name: 'الكويت', nameEn: 'Kuwait' },
    { code: '+973', flag: '🇧🇭', name: 'البحرين', nameEn: 'Bahrain' },
    { code: '+974', flag: '🇶🇦', name: 'قطر', nameEn: 'Qatar' },
    { code: '+968', flag: '🇴🇲', name: 'عمان', nameEn: 'Oman' },
    { code: '+967', flag: '🇾🇪', name: 'اليمن', nameEn: 'Yemen' },
    { code: '+964', flag: '🇮🇶', name: 'العراق', nameEn: 'Iraq' },
    { code: '+962', flag: '🇯🇴', name: 'الأردن', nameEn: 'Jordan' },
    { code: '+963', flag: '🇸🇾', name: 'سوريا', nameEn: 'Syria' },
    { code: '+961', flag: '🇱🇧', name: 'لبنان', nameEn: 'Lebanon' },
    { code: '+970', flag: '🇵🇸', name: 'فلسطين', nameEn: 'Palestine' },
    { code: '+20', flag: '🇪🇬', name: 'مصر', nameEn: 'Egypt' },
    { code: '+249', flag: '🇸🇩', name: 'السودان', nameEn: 'Sudan' },
    { code: '+218', flag: '🇱🇾', name: 'ليبيا', nameEn: 'Libya' },
    { code: '+216', flag: '🇹🇳', name: 'تونس', nameEn: 'Tunisia' },
    { code: '+213', flag: '🇩🇿', name: 'الجزائر', nameEn: 'Algeria' },
    { code: '+212', flag: '🇲🇦', name: 'المغرب', nameEn: 'Morocco' },
    { code: '+91', flag: '🇮🇳', name: 'الهند', nameEn: 'India' },
    { code: '+92', flag: '🇵🇰', name: 'باكستان', nameEn: 'Pakistan' },
    { code: '+880', flag: '🇧🇩', name: 'بنغلاديش', nameEn: 'Bangladesh' },
    { code: '+63', flag: '🇵🇭', name: 'الفلبين', nameEn: 'Philippines' },
    { code: '+62', flag: '🇮🇩', name: 'إندونيسيا', nameEn: 'Indonesia' },
    { code: '+60', flag: '🇲🇾', name: 'ماليزيا', nameEn: 'Malaysia' },
    { code: '+90', flag: '🇹🇷', name: 'تركيا', nameEn: 'Turkey' },
    { code: '+98', flag: '🇮🇷', name: 'إيران', nameEn: 'Iran' },
    { code: '+93', flag: '🇦🇫', name: 'أفغانستان', nameEn: 'Afghanistan' },
    { code: '+44', flag: '🇬🇧', name: 'بريطانيا', nameEn: 'UK' },
    { code: '+1', flag: '🇺🇸', name: 'أمريكا', nameEn: 'USA' },
    { code: '+33', flag: '🇫🇷', name: 'فرنسا', nameEn: 'France' },
    { code: '+49', flag: '🇩🇪', name: 'ألمانيا', nameEn: 'Germany' },
    { code: '+39', flag: '🇮🇹', name: 'إيطاليا', nameEn: 'Italy' },
    { code: '+34', flag: '🇪🇸', name: 'إسبانيا', nameEn: 'Spain' },
    { code: '+31', flag: '🇳🇱', name: 'هولندا', nameEn: 'Netherlands' },
    { code: '+46', flag: '🇸🇪', name: 'السويد', nameEn: 'Sweden' },
    { code: '+47', flag: '🇳🇴', name: 'النرويج', nameEn: 'Norway' },
    { code: '+45', flag: '🇩🇰', name: 'الدنمارك', nameEn: 'Denmark' },
    { code: '+41', flag: '🇨🇭', name: 'سويسرا', nameEn: 'Switzerland' },
    { code: '+43', flag: '🇦🇹', name: 'النمسا', nameEn: 'Austria' },
    { code: '+32', flag: '🇧🇪', name: 'بلجيكا', nameEn: 'Belgium' },
    { code: '+48', flag: '🇵🇱', name: 'بولندا', nameEn: 'Poland' },
    { code: '+7', flag: '🇷🇺', name: 'روسيا', nameEn: 'Russia' },
    { code: '+86', flag: '🇨🇳', name: 'الصين', nameEn: 'China' },
    { code: '+81', flag: '🇯🇵', name: 'اليابان', nameEn: 'Japan' },
    { code: '+82', flag: '🇰🇷', name: 'كوريا الجنوبية', nameEn: 'South Korea' },
    { code: '+61', flag: '🇦🇺', name: 'أستراليا', nameEn: 'Australia' },
    { code: '+64', flag: '🇳🇿', name: 'نيوزيلندا', nameEn: 'New Zealand' },
    { code: '+27', flag: '🇿🇦', name: 'جنوب أفريقيا', nameEn: 'South Africa' },
    { code: '+55', flag: '🇧🇷', name: 'البرازيل', nameEn: 'Brazil' },
    { code: '+52', flag: '🇲🇽', name: 'المكسيك', nameEn: 'Mexico' },
    { code: '+54', flag: '🇦🇷', name: 'الأرجنتين', nameEn: 'Argentina' },
  ];

  const nationalities = countries.map(c => c.name);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    if (name === 'date_of_birth' && value) {
      calculateAge(value);
    }
  };

  const calculateAge = (dateValue) => {
    if (!dateValue) return;
    const birthDate = new Date(dateValue);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setFormData(prev => ({ ...prev, age: age.toString() }));
  };

  const handleDateOfBirthChange = (value) => {
    setFormData(prev => ({ ...prev, date_of_birth: value }));
    calculateAge(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    if (!formData.full_name || !formData.national_id || !formData.phone || !formData.date_of_birth) {
      setError('يرجى تعبئة جميع الحقول المطلوبة');
      setLoading(false);
      return;
    }

    try {
      const dataToSend = {
        ...formData,
        phone: countryCode.replace('+', '') + formData.phone,
        age: formData.age ? parseInt(formData.age) : null,
        email: formData.email || null,
        address: formData.address || null,
        patient_history: formData.patient_history || null,
        reference_mrn: formData.reference_mrn || null,
      };

      const response = await customersAPI.create(dataToSend);
      const createdCustomer = response.data?.data;
      
      setSuccess('تم تسجيل العميل بنجاح! جاري التوجيه لصفحة الحجز...');
      
      setTimeout(() => {
        // Navigate to new booking page with the created customer data
        navigate('/bookings/new', { 
          state: { 
            customer: createdCustomer 
          } 
        });
      }, 1000);
    } catch (err) {
      setError(err.response?.data?.message || 'حدث خطأ أثناء تسجيل العميل');
    }

    setLoading(false);
  };

  const selectedCountry = countries.find(c => c.code === countryCode) || countries[0];

  return (
    <div className="container mx-auto px-6 py-8" dir="rtl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto"
      >
        {/* Header */}
        <div className="bg-[#1E293B] rounded-t-2xl px-6 py-5">
          <div className="flex items-center justify-center gap-3">
            <UserPlus className="w-6 h-6 text-slate-100" />
            <h1 className="text-xl font-bold text-slate-100">إضافة عميل جديد</h1>
          </div>
        </div>

        {/* Form */}
        <div className="bg-white rounded-b-2xl shadow-lg border border-gray-100 p-6 md:p-8">
          {/* Messages */}
          {error && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl flex items-center gap-3 text-red-700"
            >
              <AlertCircle className="w-5 h-5 flex-shrink-0" />
              <span>{error}</span>
            </motion.div>
          )}

          {success && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl flex items-center gap-3 text-green-700"
            >
              <CheckCircle className="w-5 h-5 flex-shrink-0" />
              <span>{success}</span>
            </motion.div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Row 1: Full Name & Nationality */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  الاسم الكامل <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  placeholder="أدخل الاسم الكامل"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">الجنسية</label>
                <select
                  name="nationality"
                  value={formData.nationality}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 appearance-none"
                >
                  {nationalities.map(nat => (
                    <option key={nat} value={nat}>{nat}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Row 2: Identity Type & ID Number */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">نوع الهوية</label>
                <select
                  name="identity_type"
                  value={formData.identity_type}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                >
                  <option value="ID">هوية وطنية</option>
                  <option value="Passport">جواز سفر</option>
                  <option value="Iqama">إقامة</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  رقم الهوية / جواز السفر <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="national_id"
                  value={formData.national_id}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  placeholder="أدخل رقم الهوية"
                  dir="ltr"
                  required
                />
              </div>
            </div>

            {/* Row 3: Mobile */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                رقم الجوال <span className="text-red-500">*</span>
              </label>
              <div className="flex gap-2 max-w-md">
                <select
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                  className="w-28 px-2 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-sm"
                  dir="ltr"
                >
                  {countries.map(country => (
                    <option key={country.code} value={country.code}>
                      {country.flag} {country.code}
                    </option>
                  ))}
                </select>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  placeholder="5XXXXXXXX"
                  dir="ltr"
                  required
                />
              </div>
            </div>

            {/* Row 4: DOB & Age */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <GregorianDatePicker
                label={<>تاريخ الميلاد <span className="text-red-500">*</span></>}
                  value={formData.date_of_birth}
                onChange={handleDateOfBirthChange}
                maxDate={new Date().toISOString().split('T')[0]}
                />

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  العمر (بالسنوات)
                </label>
                <input
                  type="text"
                  value={formData.age ? `${formData.age} سنة` : 'يحسب تلقائياً'}
                  className="w-full px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-lg text-gray-600 cursor-not-allowed"
                  disabled
                  readOnly
                />
              </div>
            </div>

            {/* Row 5: Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">البريد الإلكتروني (اختياري)</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 max-w-md"
                placeholder="example@email.com"
                dir="ltr"
              />
            </div>

            {/* Row 5: Address */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">العنوان (اختياري)</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="أدخل العنوان"
              />
            </div>

            {/* Row 6: Patient History & Reference MRN */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">التاريخ المرضي (اختياري)</label>
                <textarea
                  name="patient_history"
                  value={formData.patient_history}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 resize-none"
                  rows={2}
                  placeholder="أدخل التاريخ المرضي"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">الرقم الطبي المرجعي (اختياري)</label>
                <input
                  type="text"
                  name="reference_mrn"
                  value={formData.reference_mrn}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  placeholder="MRN"
                  dir="ltr"
                />
              </div>
            </div>

            {/* Row 7: Gender */}
            <div className="pt-2">
              <label className="block text-sm font-medium text-gray-700 mb-3 text-center">الجنس</label>
              <div className="flex justify-center gap-4">
                <button
                  type="button"
                  onClick={() => setFormData(prev => ({ ...prev, gender: 'Male' }))}
                  className={`px-10 py-2.5 rounded-full border-2 font-medium transition-all ${
                    formData.gender === 'Male'
                      ? 'border-blue-500 bg-blue-500 text-white shadow-md'
                      : 'border-gray-200 text-gray-600 hover:border-blue-300'
                  }`}
                >
                  ذكر
                </button>
                <button
                  type="button"
                  onClick={() => setFormData(prev => ({ ...prev, gender: 'Female' }))}
                  className={`px-10 py-2.5 rounded-full border-2 font-medium transition-all ${
                    formData.gender === 'Female'
                      ? 'border-pink-500 bg-pink-500 text-white shadow-md'
                      : 'border-gray-200 text-gray-600 hover:border-pink-300'
                  }`}
                >
                  أنثى
                </button>
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex justify-center pt-4">
              <motion.button
                type="submit"
                disabled={loading}
                whileHover={{ scale: loading ? 1 : 1.02 }}
                whileTap={{ scale: loading ? 1 : 0.98 }}
                className={`px-16 py-3 rounded-full font-semibold text-white transition-all ${
                  loading
                    ? 'bg-blue-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700 shadow-lg shadow-blue-500/25'
                }`}
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    جاري الحفظ...
                  </span>
                ) : (
                  'حفظ'
                )}
              </motion.button>
            </div>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default NewCustomer;
